import persisted from '@/helpers/modules/auth';

export default {
  namespaced: true,
  state: {
    environment: persisted.environment,
    token: persisted.token,
    user: persisted.user,
  },
};
